module.exports = __webpack_public_path__ + "static/375x427-Ads-Corona.a9bc8d3d.jpg";